import { Component, Input, OnInit, Self } from '@angular/core';
import { ConfigQuestion } from '../../models/config-question.interface';
import {
	ControlValueAccessor,
	UntypedFormArray,
	UntypedFormControl,
	UntypedFormGroup,
	NgControl,
} from '@angular/forms';
import { ErrorMessage } from '../../constants/enum.const';

@Component({
	selector: 'bcb-generic-number-input',
	templateUrl: './generic-number-input.component.html',
	styleUrls: ['./generic-number-input.component.scss'],
})
export class GenericNumberInputComponent
	implements ControlValueAccessor, OnInit
{
	@Input() question!: ConfigQuestion;
	@Input() errorMessage?: ErrorMessage;
	prefixIcon?: string;
	suffixIcon?: string;
	hint?: { horizontalPosition: 'start' | 'end'; value: string };

	control!: UntypedFormControl;
	parent!: UntypedFormGroup | UntypedFormArray | null;
	disabled!: boolean;

	constructor(@Self() private readonly controlDirective: NgControl) {
		controlDirective.valueAccessor = this;
	}

	onChange: (value: any) => void = () => {};

	onTouched: () => void = () => {};

	ngOnInit(): void {
		this.control = this.controlDirective.control as UntypedFormControl;
		this.parent = this.control.parent;

		this.prefixIcon = this.question.attributes?.prefixIcon;
		this.suffixIcon = this.question.attributes?.suffixIcon;
		this.hint = this.question.attributes?.hint;
	}

	writeValue(value: any): void {
		value &&
			this.controlDirective.control?.setValue(value, {
				emitEvent: false,
			});
	}

	registerOnChange(onChange: (value: any) => void): void {
		this.onChange = onChange;
	}

	registerOnTouched(onTouched: () => void): void {
		this.onTouched = onTouched;
	}

	setDisabledState(disabled: boolean): void {
		this.disabled = disabled;
	}
}
